<script>
	module.exports = {
		modelData: ['aadTeacherTipTab'],
		components: {
			demo: require('./aad-tip-tabs/aad-tips-demo.vue').default,
			protocol: require('./aad-tip-tabs/aad-tips-protocol.vue').default,
			tips: require('./aad-tip-tabs/aad-tips-tips.vue').default,
			levels: require('./aad-tip-tabs/aad-tips-levels.vue').default,
			assigning: require('./aad-tip-tabs/aad-tips-assigning.vue').default,
			'tab-container': require('components/tab-container.vue').default
		},
		mounted() {
			this.$emit('data-ready');
		}
	};
</script>
<template>
	<div class="wrapper">
		<tab-container
			model-key="aadTeacherTipTab"
			variant="pill-tabs">
			<button data-tab="demo">Classroom Demo</button>
			<button data-tab="protocol">Classroom Protocol</button>
			<button data-tab="tips">Tips/Suggestions</button>
			<button data-tab="levels">How to Select a Level</button>
			<button data-tab="assigning">How to Find &amp; Assign</button>
		</tab-container>
		<div
			class="rte"
			ref="aadTeacherTipTabPanel"
			:data-panel="aadTeacherTipTab">
			<keep-alive>
				<component :is="aadTeacherTipTab"></component>
			</keep-alive>
		</div>
	</div>
</template>
